import { baseSteps } from '../../DTC/BaseSteps';

export const initialDTCState = {
    cart: {},
    steps: baseSteps,
    currentStepId: 0,
    currentStep: null,
    screeningAnswers: {},
    availableCategories: [],
    selectedCategoryIds: [],
    unselectedCategoryIds: [],
    selectedSubcategory: null,
    availableCoOps: [],
    selectedCoOp: null,
    buildingCustomPlan: false
};
